import { render, staticRenderFns } from "./PhoneVerify.vue?vue&type=template&id=4f543db2"
import script from "./PhoneVerify.vue?vue&type=script&lang=js"
export * from "./PhoneVerify.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerify.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports